import React from "react";
import { Box, Chip, Typography } from "@mui/material"
import { StatusChip } from "../../../shared/components/StatusChip";

export const RiskDetailsCard: React.FC<{
    risk: {
        project_ref: string,
        title: string,
        category: string,
        risk_rag: string
    }
}> = ({ risk }) => {
    return (
        <Box display={'flex'} alignItems="center" justifyContent="space-between" gap={1}>
            <Box display={'flex'} flexDirection={"column"}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="caption" color="text.secondary">
                        {risk.project_ref}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        •
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {risk.category}
                    </Typography>
                </Box>
                <Typography variant="subtitle2" color="text.primary">
                    {risk.title}
                </Typography>
            </Box>
            <StatusChip variant="filled" color="red" label={risk.risk_rag} />
        </Box>
    )
};